<nav class="navbar" [class.navbar-scrolled]="isScrolled">
  <div class="container">
    <!-- Brand/Logo -->
    <div class="navbar-brand">
      <a routerLink="/" class="brand-link" (click)="closeMenu()">
        <app-logo></app-logo>
        <span class="brand-glow"></span>
      </a>
    </div>
    
    <!-- Centered Nav Links (Desktop) -->
    <div class="navbar-menu" [class.is-active]="isMenuOpen">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" 
             class="nav-link" (click)="closeMenu()">Home</a>
        </li>
        <li class="nav-item">
          <a routerLink="/services" routerLinkActive="active" 
             class="nav-link" (click)="closeMenu()">Services</a>
        </li>
        <li class="nav-item">
          <a routerLink="/works" routerLinkActive="active" 
             class="nav-link" (click)="closeMenu()">Our Works</a>
        </li>
        <li class="nav-item">
          <a routerLink="/about-us" routerLinkActive="active" 
             class="nav-link" (click)="closeMenu()">About Us</a>
        </li>
        <li class="nav-item">
          <a routerLink="/contact-us" routerLinkActive="active" 
             class="nav-link" (click)="closeMenu()">Contact Us</a>
        </li>
        <li class="nav-item dropdown" 
            [class.is-open]="isDropdownOpen">
          <button class="nav-link dropdown-toggle" 
                  [class.active]="isDropdownActive()"
                  (click)="toggleDropdown($event)"
                  aria-haspopup="true" 
                  [attr.aria-expanded]="isDropdownOpen">
            More <i class="fas fa-chevron-down dropdown-arrow" [class.rotated]="isDropdownOpen"></i>
          </button>
          <ul class="dropdown-menu" [class.show]="isDropdownOpen">
            <li class="dropdown-item-wrapper">
              <a routerLink="/careers" routerLinkActive="active" class="dropdown-item" (click)="closeMenuAndDropdown()">Careers</a>
            </li>
            <li class="dropdown-item-wrapper">
              <a routerLink="/blog" routerLinkActive="active" class="dropdown-item" (click)="closeMenuAndDropdown()">Blog</a>
            </li>
            <li class="dropdown-item-wrapper">
              <a routerLink="/faq" routerLinkActive="active" class="dropdown-item" (click)="closeMenuAndDropdown()">FAQ</a>
            </li>
          </ul>
        </li>
      </ul>
      
      <!-- Mobile-only CTA -->
      <div class="mobile-cta-wrapper">
        <a routerLink="/contact-us" class="btn btn-primary" (click)="closeMenu()">Start a Project</a>
        
        <div class="mobile-social-links">
          <a href="https://www.linkedin.com/company/finspiresoftwaresolution" target="_blank" rel="noopener noreferrer" class="social-icon linkedin" title="LinkedIn" aria-label="LinkedIn">
            <i class="fab fa-linkedin-in"></i>
          </a>
          <a href="https://www.instagram.com/fins_pire?igsh=Y3p0eHR2MDAzNjlj" target="_blank" rel="noopener noreferrer" class="social-icon instagram" title="Instagram" aria-label="Instagram">
            <i class="fab fa-instagram"></i>
          </a>
          <a href="https://www.facebook.com/share/1LaM55SZjo/" target="_blank" rel="noopener noreferrer" class="social-icon facebook" title="Facebook" aria-label="Facebook">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="https://wa.me/94764847856" target="_blank" rel="noopener noreferrer" class="social-icon whatsapp" title="WhatsApp" aria-label="WhatsApp">
            <i class="fab fa-whatsapp"></i>
          </a>
        </div>
      </div>
    </div>
    
    <!-- Right Actions: Theme Switcher, Call Button & CTA -->
    <div class="navbar-actions-wrapper">
      <!-- Phone Call Link -->
      <a href="tel:+94764847856" class="theme-toggle-btn call-btn" title="Call Finspire" aria-label="Call Finspire" style="text-decoration: none;">
        <i class="fas fa-phone"></i>
      </a>

      <!-- Theme Switcher -->
      <button (click)="toggleTheme()" class="theme-toggle-btn" [title]="isLightMode ? 'Switch to Dark Mode' : 'Switch to Light Mode'" aria-label="Toggle Theme">
        <i class="fas" [class.fa-sun]="isLightMode" [class.fa-moon]="!isLightMode"></i>
      </button>

      <div class="navbar-actions">
        <a routerLink="/contact-us" class="btn btn-outline btn-sm cta-button">
          Start a Project
          <i class="fas fa-arrow-right-long icon-arrow"></i>
        </a>
      </div>
      
      <!-- Hamburger Toggle -->
      <div class="navbar-toggle" role="button" tabindex="0" aria-label="Toggle navigation menu" (click)="toggleMenu()" (keydown.enter)="toggleMenu()" [class.is-active]="isMenuOpen">
        <span class="toggle-line"></span>
        <span class="toggle-line"></span>
        <span class="toggle-line"></span>
      </div>
    </div>
  </div>
</nav>
